import fetch from '@giro/shared-utils/fetch.util';

export default async function postApiAuthsRefreshService() {
  return fetch('auths/refresh', {
    auth: true,
    method: 'POST',
    ms: 'USERS',
  });
}
